import axios from 'axios';
import { api } from '../utils/helper';


//****************** GET Home Data By org,proj ******************//
export const getHomeShow = async () => {
  
    //console.log("OrgID from database => ", sessionStorage.getItem('org'))
  
    try {
      let a = { projID: sessionStorage.getItem('project') , orgID: sessionStorage.getItem('org') }
//      console.log("a from getHomeShow rhform => ", a.projID, a.orgID)
  
      const resrep = await axios.post(
        `${api}/gethomeshow`, a,
        {
          headers: {
            authorization: sessionStorage.getItem('token'),
          },
        },
      );
  
//      console.log(`getHomeShow controller res: `, resrep);
      return resrep;
    } catch (error) {
//      console.log(`getHomeShow controller error: `, error?.response?.data);
      alert(error?.response?.data?.message);
    }
  
  }

//****************** GET Organization Data for Dashboard ******************//
export const getOrgForDashboard = async () => {
  try {
    return await axios.post(
      `${api}/getorgfordashboard`,
      {},
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );
  } catch (error) {
    alert(error?.response?.data?.message);
  }
}

//****************** GET Township Data By org,proj ******************//
export const getTownshipForDashboard = async (filters = {}) => {
  
    //console.log("OrgID from database => ", sessionStorage.getItem('org'))
  
    try {
      let a = {
        projID: sessionStorage.getItem('project'),
        orgID: sessionStorage.getItem('org'),
        ...filters
      }
  
      const resrep = await axios.post(
        `${api}/gettownshipfordashboard`, a,
        {
          headers: {
            authorization: sessionStorage.getItem('token'),
          },
        },
      );
  
//      console.log(`getTownshipForDashboard controller res: `, resrep);
      return resrep;
    } catch (error) {
//      console.log(`getTownshipForDashboard controller error: `, error?.response?.data);
      alert(error?.response?.data?.message);
    }
  
  }

//****************** GET clinic org,proj,tsp ******************//
export const getClinicForDashboard = async (a) => {
  
  
    try {
  
      const resrep = await axios.post(
        `${api}/getclinicfordashboard`, a,
        {
          headers: {
            authorization: sessionStorage.getItem('token'),
          },
        },
      );
  
      return resrep;
    } catch (error) {
      alert(error?.response?.data?.message);
    }
  
  }

const getIndiByNo = async (no, a) => {
  try {
    const resrep = await axios.post(
      `${api}/getindi${no}`,
      a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );

    return resrep;
  } catch (error) {
    alert(error?.response?.data?.message);
  }
}

//****************** GET indi1 ******************//
export const getIndi1 = async (a) => getIndiByNo(1, a)

//****************** GET indi2 ******************//
export const getIndi2 = async (a) => getIndiByNo(2, a)

//****************** GET indi3 ******************//
export const getIndi3 = async (a) => getIndiByNo(3, a)

//****************** GET indi4 ******************//
export const getIndi4 = async (a) => getIndiByNo(4, a)

//****************** GET indi5 ******************//
export const getIndi5 = async (a) => getIndiByNo(5, a)

//****************** GET indi6 ******************//
export const getIndi6 = async (a) => getIndiByNo(6, a)

//****************** GET indi7 ******************//
export const getIndi7 = async (a) => getIndiByNo(7, a)

//****************** GET indi8 ******************//
export const getIndi8 = async (a) => getIndiByNo(8, a)

//****************** GET indi9 ******************//
export const getIndi9 = async (a) => getIndiByNo(9, a)

//****************** GET indi10 ******************//
export const getIndi10 = async (a) => getIndiByNo(10, a)

//****************** GET indi11 ******************//
export const getIndi11 = async (a) => getIndiByNo(11, a)

//****************** GET indi12 ******************//
export const getIndi12 = async (a) => getIndiByNo(12, a)

//****************** GET indi13 ******************//
export const getIndi13 = async (a) => getIndiByNo(13, a)

//****************** GET indi14 ******************//
export const getIndi14 = async (a) => getIndiByNo(14, a)

//****************** GET indi15 ******************//
export const getIndi15 = async (a) => getIndiByNo(15, a)

//****************** GET indi16 ******************//
export const getIndi16 = async (a) => getIndiByNo(16, a)

//****************** GET indi17 ******************//
export const getIndi17 = async (a) => getIndiByNo(17, a)